import ImageTooltipComp from 'components/ImageTooltipComp';
import Loading from 'components/Loading';
import PageHeader from 'components/PageHeader';
import SkillComponent from 'components/SkillComponent';
import { useState, useEffect } from 'react';
import { Container, Row } from 'react-bootstrap';

const data = [
    {
        Title: 'Languages',
        skills: [
            {
                Title: 'Greek',
                img: require('images/flags/greece.png'),
            },
            {
                Title: 'English',
                img: require('images/flags/uk.png'),
            },
        ],
    },
    {
        Title: 'LinkedIn Skills',
        skills: [
            {
                Title: 'Python',
                img: require('images/programming_languages/python.png'),
            },
            {
                Title: 'Javascript',
                img: require('images/programming_languages/javascript.png'),
            },
            {
                Title: 'Git',
                img: require('images/linkedin_skills/git.png'),
            },
            {
                Title: 'Front-End Development',
                img: require('images/linkedin_skills/frontend.png'),
            },
            {
                Title: 'Cybersecurity',
                img: require('images/linkedin_skills/cybersecurity.png'),
            },
        ],
    },
    {
        Title: 'Full-Stack Developer',
        children: [
            {
                Title: 'Back-End Development',
                skills: [
                    {
                        Title: 'Python',
                        img: require('images/programming_languages/python.png'),
                    },
                    {
                        Title: 'Django',
                        img: require('images/frameworks/django.png'),
                    },
                    {
                        Title: 'JSON Web Token',
                        img: require('images/frameworks/jwt.png'),
                    },
                    {
                        Title: 'SQlite',
                        img: require('images/frameworks/sqlite.png'),
                    },
                    {
                        Title: 'PostgreSQL',
                        img: require('images/frameworks/postgres.png'),
                    },
                    {
                        Title: 'MySQL',
                        img: require('images/frameworks/mysql.png'),
                    },
                ],
            },
            {
                Title: 'Front-End Development',
                skills: [
                    {
                        Title: 'React',
                        img: require('images/frameworks/react.png'),
                    },
                    {
                        Title: 'Vue',
                        img: require('images/frameworks/vue.png'),
                    },
                    {
                        Title: 'Bootstrap',
                        img: require('images/frameworks/bootstrap.png'),
                    },
                    {
                        Title: 'Javascript',
                        img: require('images/programming_languages/javascript.png'),
                    },
                    {
                        Title: 'Typescript',
                        img: require('images/programming_languages/typescript.png'),
                    },
                    {
                        Title: 'HTML',
                        img: require('images/programming_languages/html.png'),
                    },
                    {
                        Title: 'CSS',
                        img: require('images/programming_languages/css.png'),
                    },
                    {
                        Title: 'Sass',
                        img: require('images/frameworks/sass.png'),
                    },
                ],
            },
        ],
    },
    {
        Title: 'Hobbies',
        children: [
            {
                Title: 'CTF Player',
                skills: [
                    {
                        Title: 'Cryptography',
                        img: require('images/cybersecurity/cryptography.png'),
                    },
                    {
                        Title: 'Forensics',
                        img: require('images/cybersecurity/forensics.png'),
                    },
                ],
            },
            {
                Title: 'Athlete',
                skills: [
                    {
                        Title: 'Kung Fu',
                        img: require('images/martial_arts/kung_fu.png'),
                    },
                    {
                        Title: 'Judo',
                        img: require('images/martial_arts/judo.png'),
                    },
                    {
                        Title: 'Boxing',
                        img: require('images/martial_arts/boxing.png'),
                    },
                ],
            },
        ],
    },
];

export default function Extras() {
    const [data, setData] = useState<any>(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(
                    'https://api.myjson.online/v1/records/2cea729f-3e7d-4822-b1a4-e093964d055f',
                    {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'm-collection-access-token':
                                '14fd5407-a000-42bb-92d8-a885c8f90f8b',
                        },
                    }
                );
                const json = await response.json();
                setData(json.data);
            } catch (error) {
                console.log('error', error);
            }
        };
        fetchData();
    }, []);

    return (
        <Container className='p-3'>
            <PageHeader
                Title='Extras'
                Description='Here is some extra information about me.'
            />
            <Loading show={!data}>
                <Row>
                    {data &&
                        data.extras.map((item: any, index: any) => {
                            return (
                                <SkillComponent
                                    key={index}
                                    Title={item.Title}
                                    Parrent={item.children ? true : false}
                                >
                                    {item.children
                                        ? item.children.map(
                                              (child: any, index: any) => {
                                                  return (
                                                      <SkillComponent
                                                          key={index}
                                                          Title={child.Title}
                                                      >
                                                          {child.skills.map(
                                                              (
                                                                  skill: any,
                                                                  index: any
                                                              ) => {
                                                                  return (
                                                                      <ImageTooltipComp
                                                                          key={
                                                                              index
                                                                          }
                                                                          img={
                                                                              skill.img
                                                                          }
                                                                          text={
                                                                              skill.Title
                                                                          }
                                                                      />
                                                                  );
                                                              }
                                                          )}
                                                      </SkillComponent>
                                                  );
                                              }
                                          )
                                        : item.skills.map(
                                              (skill: any, index: any) => {
                                                  return (
                                                      <ImageTooltipComp
                                                          key={index}
                                                          img={skill.img}
                                                          text={skill.Title}
                                                      />
                                                  );
                                              }
                                          )}
                                </SkillComponent>
                            );
                        })}
                </Row>
            </Loading>
        </Container>
    );
}
